module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-1280x160-e8fb141c6c9a73cb6fcbab9d59720714.webp";